// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3C%3Fxml version=%271.0%27 encoding=%27UTF-8%27%3F%3E%3Csvg width=%2714px%27 height=%2710px%27 viewBox=%270 0 14 10%27 version=%271.1%27 xmlns=%27http://www.w3.org/2000/svg%27 xmlns:xlink=%27http://www.w3.org/1999/xlink%27%3E%3C%21-- Generator: Sketch 59.1 %2886144%29 - https://sketch.com --%3E%3Ctitle%3Echeck%3C/title%3E%3Cdesc%3ECreated with Sketch.%3C/desc%3E%3Cg id=%27Page-1%27 stroke=%27none%27 stroke-width=%271%27 fill=%27none%27 fill-rule=%27evenodd%27%3E%3Cg id=%27ios_modification%27 transform=%27translate%28-27.000000, -191.000000%29%27 fill=%27%23FFFFFF%27 fill-rule=%27nonzero%27%3E%3Cg id=%27Group-Copy%27 transform=%27translate%280.000000, 164.000000%29%27%3E%3Cg id=%27ic-check-18px%27 transform=%27translate%2825.000000, 23.000000%29%27%3E%3Cpolygon id=%27check%27 points=%276.61 11.89 3.5 8.78 2.44 9.84 6.61 14 15.56 5.05 14.5 4%27%3E%3C/polygon%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAYCAYAAACMcW/9AAAACXBIWXMAACE4AAAhOAFFljFgAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACnSURBVHgBzdfJDcAgDARAd04JlOASKYEEEn8SQjh8rWSJB2JHiA8AV8I56Z4I9ml6yiI/BsEuCG9PgVd1Bh9Y/LCkHlQbix1HhYbOBi0s/hji6EZJ7HS3BXa5UxO73aWBZeuQxLKfLYEVuwDOg8WfFEeBOJKjSA25U6iOXCk2Q84AzJGjWBfIHaw6kjKDNUNSRrDmSEoP6wZJaWHdISnly0Df3ACMOQATckHecQwCXQAAAABJRU5ErkJggg==", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../Assets/selectSuc.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/png;base64,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", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../Assets/selectArrow.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gapStyle{
  column-gap: 40px !important;
  row-gap:10px !important;
}

.textArea,.textAreaError {
  white-space: nowrap;  
  overflow-x: auto;   
    color:  #424242;;
  background-color: #fff;
  border: 1px solid #797979;
  border-radius: 4px;
  width:248px;
  height: 40px; 
  resize: none; 
  line-height: 35px;
}
.textAreaError{
  line-height: 39px;
}

.textArea::-webkit-scrollbar,.textAreaError::-webkit-scrollbar {
  display: none;
}
.textArea:focus {
  outline: none; 
}
.checkbox {
  position: relative;
  overflow: hidden;
  background: none;
  margin-top: 11px;
}

.create-feis-content{
padding-left:18%;
padding-right: 10%;
}

#TabSize {
  /* position: absolute !important; */
  padding:0;
}
.checkbox__input {
  position: absolute;
  top: -100px;
  left: -100px;
}

.newLevelField {
  border: 1px solid var(--neutral-chips, #797979);
  width: auto;
  height: 42px;
  border-radius: 4px;
}

.newLevelField:focus-visible {
  outline: none;
}

.checkbox__inner {
  display: inline-block;
  width: 19px;
  height: 19px;
  border-radius: 28%;
  border: 1px solid #626262;
  background: transparent no-repeat center;
}

.checkbox__input:checked + .checkbox__inner {
  border-color: #68ad3f;
  background-color: #68ad3f;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: 14px 10px;
}

.formikSelectSignorg {
  width: 248px;
}

.input-box-org {
  color: #424242;
  width: 248px;
  height: 40px;
  border: 1px solid #797979;
  border-radius: 4px;
  padding-left: 9.94px;
  outline: none;
}

.calendar-icon {
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
}

.label-head-org {
  font-weight: 500;
  font-size: 12px;
  margin: 11px auto 3px 5px;
  color: #000000;
  padding: 0px !important;
}

.card-header {
  background-color: #68ad3f !important;
  color: #ffffff !important;
}

.card-currency {
  background-color: #68ad3f;
  color: #ffffff;
  font-family: 'Rubik';
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  padding: 4px;
}

.card-cont {
  font-size: 16px;
}

.card-body {
  padding: 10px !important;
}

.pdfDlticon {
  color: #da1414;
  cursor: pointer;
}

/* .fileIcon {
  padding-right: 20px;
  padding-left: 22px;
  color: #424242;
} */

.fileIcon svg {
  rotate: 90deg;
}

.uploadeDIv {
  width: 410px;
  min-height: 48px;
  background: #ffffff;
  box-shadow: 0px 4px 18px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  font-size: 14px;
  color: #424242;
}

.label-head-org iframe {
  margin-top: 2px;
}

.AddedAdj,
.AddedAdjCollab {
  width: 312px;
  height: 61px;
  display: flex;
  justify-content: space-between;
  padding: 10.14px 9px 8.89px 14px;
  background: #ffffff;
  box-shadow: 0px 15px 28px rgba(0, 0, 0, 0.05);
  border-radius: 4px;
  align-items: center;
  margin-top: 8px;
  margin-bottom: 8px;
}

.rightDivAdj svg {
  cursor: pointer;
}

.updateChangeDisabled-org-finish:hover {
  background: #fbb040;
  cursor: pointer;
}

.leftDivAdj {
  display: flex;
}

.adjImg {
  display: flex;
  align-items: center;
}

.adjImg-adj {
  display: flex;
  align-items: center;
}

.adjDes {
  display: flex;
  flex-direction: column;
  padding-left: 10px;
}

.adjNAme {
  font-weight: 400;
  font-size: 16px;
  color: #424242;
}

.adjCoun {
  font-weight: 500;
  font-size: 12px;
  color: #68ad3f;
  opacity: 0.6;
}

.rightDivAdj svg {
  color: #da1414;
  opacity: 0.6;
  height: 16px;
}

.auth-suc {
  color: #68ad3f;
  font-size: 12px;
}

.adjdet {
  font-family: 'Rubik';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  color: #424242;
}

.adjImg img {
  width: 25.14px;
  height: 25.14px;
  border-radius: 50%;
}

.input-box-org-select,.input-box-org-select-disabled {
  -webkit-appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-position: top 50% right 6%;
  background-repeat: no-repeat;
  background-size: 15px 8px !important;
  background-size: 4%;
  width: 248px;
  padding: 0px 27px 0px 13px;
  font-size: 14px;
  height: 40px;
}

.input-box-org-select-disabled{
  opacity:0.6 !important;
}
.levelCap-Values > div {
  display: flex;
  flex-direction: column;
}
.levelCap-Values > div input {
  margin-top: 2px !important;
}
.label-head-org-file-error {
  font-weight: 500;
  font-size: 12px;
  margin: 3px 5px;
  color: red;
  padding: 0px !important;
}
.label-head-org-file {
  font-weight: 500;
  font-size: 12px;
  color: #000000;
  padding: 0px !important;
  margin: 3px 5px;
}

.input-box-org:focus {
  color: #000000;
  width: 248px;
  height: 40px;
  border: 1px solid #68ad3f;
  border-radius: 4px;
  padding-left: 10px;
  outline: none;
  color: #68ad3f;
}
.input-text-accomodation-des:focus {
  color: #000000;
  border: 1px solid #68ad3f;
  border-radius: 4px;
  outline: none;
  color: #68ad3f;
}

.input-control:focus-within label {
  color: #68ad3f;
}

.input-control:focus-visible textarea{
  border: 1px solid #da1414;
  outline: none;
}

.input-control:focus-within textarea {
  border: 1px solid #68ad3f;
  color: #68ad3f;
}

.error-input {
  border: 1px solid red;
  width: 55px;
  height: 42px;
  border-radius: 6px;
  padding-left: 11px;
}

.error-des {
  border: 1px solid red;
  width: 140px;
  height: 43px;
  border-radius: 6px;
  /* padding-left: 23px; */
text-align: center;
}
.error-des::placeholder{
  margin-left: 0;
}
.error-des:focus {
  border: 1px solid red;
}

.error-select {
  border: 1px solid red;
  width: 80px;
  height: 41px;
  border-radius: 6px;
  font-size: 14px;
  color: red;
  padding: 0 3px;
}

.mainDivLive {
  margin-top: 32px !important;
}

.input-box-org-date:focus {
  width: 248px;
  height: 40px;
  border-radius: 4px;
  outline: none;
  padding: 0px 10px;
  cursor: text;
  border: 1px solid #68ad3f;
  color: #68ad3f;
}

.input-box-org-date-disabled {
  width: 248px;
  height: 40px;
  border-radius: 4px;
  outline: none;
  padding: 0px 10px;
  cursor: text;
  border: 1px solid #797979;
  color: rgba(0, 0, 0, 0.5);
}

.input-box-org-select:focus {
  -webkit-appearance: none;
  background-position: top 50% right 6%;
  background-repeat: no-repeat;
  background-size: 15px 8px !important;
  background-size: 4%;
  width: 248px;
  border: 1px solid #68ad3f;
  color: #68ad3f;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

.label-select-org-error {
  margin: 12px auto 3px 7px;
  font-size: 12px;
  color: red;
}

.input-box-select-error {
  -webkit-appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  background-position: top 50% right 6%;
  background-repeat: no-repeat;
  background-size: 15px 8px !important;
  background-size: 4%;
  width: 248px;
  color: red;
  font-size: 14px;
  border: 1px solid red;
  height: 40px;
  padding: 0px 27px 0px 13px;
}

.input-box-org-select-error {
  -webkit-appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  background-position: top 50% right 6%;
  background-repeat: no-repeat;
  background-size: 15px 8px !important;
  background-size: 4%;
  width: 248px;
  color: red;
  font-size: 14px;
  border: 1px solid red;
  height: 40px;
  padding: 0px 27px 0px 13px;
}

.input-box-org-select-error {
  color: red;
}

.input-text-area {
  width: 410px;
  height: 128px;
  padding: 10px 8px;
  border-radius: 5px;
  border: 1px solid #424242;
  margin-top: 3px;
}

.input-text-area-error {
  width: 410px;
  height: 128px;
  padding: 10px 8px;
  border-radius: 5px;
  border: 1px solid #da1414;
  margin-top: 3px;
}

.input-text-area-length {
  width: 410px;
  text-align: right;
  margin-top: -6px;
  color: #424242;
}

.sylSlect {
  width: 80px;
  height: 41px;
  border-radius: 6px;
  font-size: 14px;
  border: 1px solid #797979;
  padding: 0 3px;
  text-align: center;
  padding: 0 15px 0 8px;
  -webkit-appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  background-size: 9px 5px !important;
  background-repeat: no-repeat;
  background-position: top 53% right 10%;
}
.sylSlectGender {
  width: 80px;
  height: 41px;
  border-radius: 6px;
  font-size: 14px;
  border: 1px solid #797979;
  padding: 0 15px 0 8px;
  text-align: left;
  -webkit-appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  background-size: 9px 5px !important;
  background-repeat: no-repeat;
  background-position: top 53% right 10%;
}


table {
  border-collapse: collapse;
}

thead th:first-child {
  border-radius: 4px 0 0 0 !important;
}

thead th:last-child {
  border-radius: 0 4px 0 0;
}

.stripeContainer {
  padding: 0px 50px !important;
}

.sveSyllabus {
  color: #68ad3f;
  cursor: pointer;
}

.auth-error-syl {
  color: red;
  font-size: 12px;
  height: 0px;
}

.iconsave {
  display: flex;
  gap: 29px;
  align-items: center;
}

.DidnontFind {
  font-family: 'Rubik';
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  color: #000000;
  margin-top: 20px;
}

.input-box-org-des-error {
  width: 248px;
  height: 120px;
  border: 1px solid red;
  outline: none;
  color: red;
}

.syllabusMain input::placeholder {
  color: #c9c9c9 !important;
}

#feisOrgGrade .MuiTabs-indicator {
  height: 3px !important;
}

.headingOrg {
  display: flex;
  margin-top: 2rem;
  padding: 0 7%;
}

.sylCheckbox[type='checkbox'] {
  vertical-align: middle;
  accent-color: #5a9935;
  margin-right: 10px;
  border: 2px solid;
  border-radius: 197px;
  height: 64px;
  width: 20px;
  color: #797979;
}

.input-text-area:focus-visible {
  outline: none;
}

.accordion-button {
  box-shadow: none;
  align-items: flex-end;
}

.accordion-button:focus {
  z-index: 3;
  border-color: #ffffff;
  outline: 0;
  box-shadow: none !important;
  border-color: #eaeaea;
}

.organizerExam {
  color: #424242;
  justify-content: center;
  align-items: center;
  font-weight: 400;
  font-size: 24px;
  padding-left: 1.5rem;
}

.accordion-item {
  border: none !important;
}

.AccomodationHead button {
  box-shadow: none;
  border: none !important;
}

.eventDetailsBlock {
  font-family: 'Rubik';
  font-style: normal;
  font-weight: 500;
  font-size: 22px;
  color: #424242;
}

.LiveData {
  color: #424242;
  margin-top: 10px;
}

.eventsHr {
  margin: 0px;
  margin-top: 8px;
  background-color: #eaeaea;
  height: 1.3px;
}

.goLiveMAin {
  background-color: #eaeaea;
  height: 2px;
}

.latefee {
  justify-content: space-between;
}

.subKey {
  opacity: 0.6;
}

.abountEventLive .dummy {
  width: 65%;
}

.abountEventLive .dummy2 {
  width: 35%;
}

.fileShow {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 9px 11px;
  gap: 8px;
  width: 358px;
  height: auto;
  background: #ffffff;
  box-shadow: 0px 4px 18px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
}

.attachFile {
  rotate: 90deg;
  font-size: 1.2rem !important;
}

.ROwLive {
  justify-content: space-between;
}

.detailsHeading {
  font-weight: 500;
  font-size: 12px;
  color: #000000;
  padding-top: 17px;
}

.editIcon {
  float: right;
  color: #68ad3f;
  cursor: pointer;
  margin-right: 20px;
}

.OrgGradeMain .MuiTabs-flexContainer {
  margin: auto;
  justify-content: center;
  gap: 40px;
}

.steps {
  font-size: 14px;
  line-height: 17px;
  color: #323232;
  opacity: 0.2;
}

.updateChangeDisabledOrg {
  opacity: 0.3;
  background-color: #68ad3f !important;
  color: white !important;
  pointer-events: none;
}

.input-text-accomodation,
.input-text-accomodation-des {
  width: 248px;
  height: 120px;
}

.input-text-accomodation::placeholder {
  padding-left: 40%;
  padding-top: 15%;
}

.updateChange {
  width: fit-content;
  height: 42px;
  padding: 9px 11px;
}

.updateChange:hover {
  background-color: rgb(251, 176, 64);
}

.accordion-body {
  padding: unset !important;
}

.updateChangeOrg {
  cursor: pointer;
  background-color: #68ad3f !important;
  color: white !important;
  border: 2px solid #68ad3f !important;

  padding: 9px 11px;
}

.updateChangeOrgDisabled {
  cursor: pointer;
  background-color: #68ad3f !important;
  color: white !important;
  border: 2px solid #68ad3f !important;
  padding: 9px 11px;
  opacity: 0.75;
  cursor: not-allowed;
}

.list-group {
  width: 248px;
}

.list-group-item + .list-group-item {
  border-top-width: 0;
  cursor: pointer !important;
}

.list-group-item:first-child {
  border-top-left-radius: inherit;
  border-top-right-radius: inherit;
  cursor: pointer !important;
}

.abountEventLive {
  display: flex;
  justify-content: space-between;
}

.strConnect {
  font-weight: 500;
  font-size: 16px;
  line-height: 150%;
  background-color: #68ad3f;
  color: #ffffff;
  box-shadow: none;
  border-radius: 4px;
  padding: 9px 11px;
  border: none;
  margin-top: 1em;
  border: 2px solid #68ad3f;
  margin: 1.5rem 0px 20px 0px;
  height: 45px;
  width: fit-content;
}

.strConnect:hover {
  background-color: #fbb040;
  border: 2px solid #fbb040;
}

.stripeLink {
  display: flex;
  column-gap: 12px;
}

.sylmainInput {
  display: flex;
  width: 311.5px;
  padding: 9px 0px 10px 9.94px;
  align-items: center;
  border-radius: 4px;
  border: 1px solid var(--neutral-chips, #797979);
  background: var(--neutral-white, #fff);
}

.accordion-button:not(.collapsed)::after {
  filter: brightness(0);
}

.updateChangeOrg:hover {
  background-color: rgb(251, 176, 64) !important;
  border: 2px solid rgb(251, 176, 64) !important;
}

.OrgBackSubBtns {
  gap: 27px;
  display: flex;
}

.OrgBack button {
  border: none;
  color: #68ad3f !important;
  margin-top: 1em;
  color: #68ad3f;
  font-family: 'Rubik';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 150%;
  text-align: center;
  color: #68ad3f;
  background: inherit;
  box-shadow: none;
  padding-left: 0;
}

.OrgGradeMain .Mui-selected {
  padding: 0px !important;
}

.OrgGradeMain .MuiContainer-root {
  padding: 0px !important;
}

.Aboutevent {
  padding-right: 6rem;
}

.OrgGradeMain .MuiButtonBase-root {
  padding: 0px !important;
}

.plusIconbtn .css-84skdf-MuiButtonBase-root-MuiButton-root:hover:hover {
  border: 1px solid #fbb040 !important;
}

.GradeOrgTabList{
  padding-left: 18%;
  padding-right: 18%;
}

.GradeOrgTabList .MuiTabs-indicator {
  height: 3px !important;
  border-radius: 4px;
}

.GradeOrgTabList .Mui-selected {
  color: #68ad3f;
  opacity: 1 !important;
}

.GradeOrgTabList .MuiButtonBase-root {
  padding: 0px !important;
  color: #424242;
  opacity: 0.6;
  font-weight: 400;
  min-width: 0 !important;
}

.GradeOrgTabList .MuiContainer-root {
  padding: 0px !important;
}

.GradeOrgTabList .MuiTabPanel-root {
  color: #68ad3f;
  padding: 0px;
}

.GradeOrgTabList .MuiTabs-scroller {
  position: relative;
  display: inline-block;
  flex: 1 1 auto;
  white-space: nowrap;
  overflow-x: hidden;
  width: 100%;
  overflow-x: scroll !important;
}

.GradeOrgTabList .css-1c0cfyw {
  width: 100%;
  margin-left: auto;
  box-sizing: border-box;
  margin-right: auto;
  display: block;
  padding-left: 0px;
  padding-right: 16px;
}

.eventSection {
  display: flex !important;
}

.org-select {
  margin: 12px auto 3px 7px;
  font-size: 12px;
  color: #000000;
}

.input-text-area::-webkit-scrollbar {
  display: none;
}

.input-text-accomodation-des::-webkit-scrollbar {
  display: none;
}

.adjImg-acc {
  position: absolute;
  width: 89.64px;
  height: 99.74px;
  left: 0px;
  top: 0px;
}

.rightDivAdj {
  padding: 7px 9px 7px 10px;
  margin-top: -16px;
}

.AddedAdj-dec {
  width: 312px;
  height: 61px;
  display: flex;
  justify-content: space-between;
  /* padding: 10px 21px; */
  background: #ffffff;
  box-shadow: 0px 15px 28px rgba(0, 0, 0, 0.05);
  border-radius: 4px;
  align-items: center;
  margin-top: 8px;
  width: 311px;
  height: 100px;
  background: #ffffff;
  box-shadow: 0px 15px 28px rgba(0, 0, 0, 0.05);

  flex: none;
  order: 1;
  flex-grow: 0;
  margin-bottom: 8px;
}

.adjImg-adj img {
  height: 100px;
  aspect-ratio: 1/1;
  border-radius: 4px 0px 0px 4px;
}

.goLiveDes {
  max-height: 219px;
  display: inline-grid;
  overflow: scroll;
  width: 482px;
  padding: 0px 5px;
}

.latefee div {
  width: 50%;
}

.goLiveDes::-webkit-scrollbar {
  display: none;
}

.eventPage {
  font-family: 'Rubik';
  font-style: normal;
  font-weight: 500;
  font-size: 22px;
  line-height: 120%;
  color: #424242;
}

.eventDescription {
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  color: #424242;
  border-bottom: 1px solid #eaeaea;
  padding-bottom: 8px;
  margin-bottom: 28px;
}

.paymentTab button {
  min-width: 0;
}

.input-box-org-date {
  color: #000000;
  width: 248px;
  height: 40px;
  border: 1px solid #797979;
  border-radius: 4px;
  outline: none;
  padding: 0px 10px;
  cursor: text;
}

.EventDateOrg {
  font-weight: 500;
  font-size: 22px !important;
  color: #323232;
  padding: 32px 0px 0px 0px;
}

.detailsHeaders {
  padding: 20px 0px 0px 0px;
}

.connectOrgAccount {
  font-family: 'Rubik';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 150%;
  color: #68ad3f;
  background: inherit;
  box-shadow: none;
  border-radius: 4px;
  padding: 9px 11px;
  border: none;
  margin-top: 1em;
  border: 2px solid #68ad3f;
  margin: 1.5rem 0px 20px 0px;
  height: 45px;
  width: max-content;
}
.connectOrgAccountstripe {
  font-family: 'Rubik';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 150%;
  color: #68ad3f;
  background: inherit;
  box-shadow: none;
  border-radius: 4px;
  padding: 9px 11px;
  border: none;
  margin-top: 1em;
  border: 2px solid #68ad3f;
  margin: 1.5rem 0px 20px 0px;
  height: 45px;
  width: fit-content;
}

.updateChangeDisabled-org {
  opacity: 0.3;
  background-color: #68ad3f !important;
  color: white !important;
  pointer-events: none;
  width: 59px;
  height: 42px;
  padding: 9px 11px;
}

.EventHeader-org h4 {
  font-family: 'Rubik';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 150%;
  padding: 6px 0px 6px 0px;
  color: #323232;
}

.connectOrgAccount:hover {
  background: #fbb040;
  color: #ffffff;
  border: 2px solid #fbb040;
}

.dltSyllabus {
  color: #da1414;
  cursor: pointer;
}

.plusIconbtn:hover #plusICon {
  visibility: collapse !important;
  width: 0px;
  transition-property: width;
  transition-duration: 0.3s;
  border: 2px solid;
}

.plusIconbtn .css-i4bv87-MuiSvgIcon-root {
  margin: 0 5px 0 0;
}

.plusIconbtnOrg {
  font-family: 'Rubik';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  color: #68ad3f;
}

.plusIconbtnOrg :hover #plusICon {
  visibility: collapse !important;
  width: 0px !important;
  transition-property: width !important;
  transition-duration: 0.3s !important;
  border: '2px solid' !important;
  background: #fbb040 !important;
  color: '#ffffff' !important;
  border-radius: '2px solid #fbb040' !important;
  background: #fbb040 !important;
  color: white;
  border: 1px solid #fbb040 !important;
}

.plusIconbtnOrg .css-i4bv87-MuiSvgIcon-root {
  margin: 0 5px 0 0;
}

.updateChangeDisabled-org-finish {
  font-weight: 500;
  font-size: 16px;
  line-height: 150%;
  padding: 9px 11px;
  color: #ffffff;
}

.plusIconbtnOrg .css-i4bv87-MuiSvgIcon-root:hover {
  margin: 0 5px 0 0;
  background: #fbb040 !important;
}

.OrgGradeMain .css-xdmu94-MuiContainer-root {
  padding: 0px;
}

.backdiv {
  color: #68ad3f;
  padding: 17px 0px 16px 0px;
}

.BackMain {
  font-weight: 500;
  font-size: 16px;
  padding-left: 11.59px;
  text-align: center;
}

.logoImg {
  padding-top: 13px;
  display: flex;
  gap: 9px;
}

.SYLiCON {
  cursor: pointer;
}

.SYLiCON-save {
  fill: #da1414 !important;
  cursor: pointer;
}

.SYLiCON-save-disabled {
  fill: #000000 !important;
  opacity: 0.6;
}

.logoImg img {
  width: 40.75px;
  height: 39px;
  left: -2.19px;
  bottom: 0px;
}

.EventNAme {
  font-weight: 400;
  font-size: 24px;
  text-align: center;
  color: #424242;
}

.ExamNAme {
  font-weight: 500;
  font-size: 12px;
  text-align: center;
  color: #68ad3f;
  padding: 2px 0px 0px 10px;
}

.goLiveButton button {
  background: #68ad3f;
  color: #ffffff;
  padding: 9px 11px;
  border-radius: 4px;
  border: 2px solid #68ad3f;
}

.goLiveButton button:hover {
  background: #fbb040;
  border: 2px solid #fbb040;
}

.examVenue {
  font-weight: 400;
  font-size: 14px;
  color: #000000;
  padding-left: 9px;
}

.userLevel {
  font-family: 'Rubik';
  font-style: normal;
  font-weight: 500;
  font-size: 22px;
  color: #424242;
}

.deleteIcon svg {
  color: #68ad3f;
  margin-left: 21px;
}

.deleteLevel {
  font-family: 'Rubik';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  text-align:center;
  color: #68ad3f;
}

.accordion-button {
  background-color: #ffffff !important;
  border-color: #ffffff;
}

#accordationHeader button {
  padding: 3px !important;
}

.deleteButton {
  border: none;
  box-shadow: none;
  background-color: inherit !important;
}

.header-item > button {
  padding-left: 0;
  padding-right: 0;
  width: 100%;
}

.accordion-item {
  box-shadow: none;
}

.updateLevel {
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 150%;
  color: #68ad3f;
  border: 2px solid #68ad3f !important;
  flex: none;
  order: 1;
  flex-grow: 0;
  box-shadow: none;
  margin-left: 20px !important;
  border-radius: 4px !important;
}

.updateLevel:hover {
  border: 2px solid #fbb040 !important;
  background: #fbb040 !important;
  color: #ffffff !important;
  border-radius: 2px solid #fbb040 !important;
}

.accordion-button:not(.collapsed)::after {
  background-image: var(--bs-accordion-btn-active-icon);
  transform: var(--bs-accordion-btn-icon-transform);
  color: black !important;
  background-image: balck;
}

.input-box-org-date-error {
  color: #000000;
  width: 248px;
  height: 40px;
  border: 1px solid red;
  border-radius: 4px;
  outline: none;
  padding: 0px 10px;
  color: red;
}

.tableHeadSyl {
  background: #eaeaea;
  border-radius: 2px;
  margin-top: 3rem;
}

.tableSylTh {
  font-weight: 400;
  font-size: 14px;
  align-items: center;
  color: #424242;
  text-align: center;
  background: #EAEAEA !important;
}

.sylTablediv {
  width: 67vw !important;
  overflow-x: scroll !important;
}

.sylcode {
  width: 55px;
  height: 42px;
  border-radius: 6px;
  /* padding-left: 11px; */
  border: 1px solid #797979;
text-align: center;
}

.sylcode::placeholder {
  padding: 1px;
  margin-left:0;
}

.sylageCode {
  margin: 1px;
}

.syldes {
  width: 140px;
  height: 43px;
  border-radius: 6px;
  /* padding-left: 23px; */
  border: 1px solid #797979;
text-align: center;
padding-left: 5px;
}

.agesselected {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 5px;
  height: 31px;
  background: #6c757d;
  color: #ffffff;
  border: 1px solid #424242;
  margin: 2px;
  cursor:pointer;
}

.agesselected input,.agesunselected input{
  display: none !important;
}


.agesunselected {
  color: #000000;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 5px;
  height: 31px;
  background: #f8f9fa;
  border: 1px solid #f8f9fa;
  margin: 2px;
  cursor:pointer;
}

.syldes::placeholder {
  padding-left: 1px;
  margin-left: 0;
}

.agesCodetd {
  display: flex;
  flex-wrap: wrap;
  text-decoration: none;
  padding: 9px 0px !important;
  align-items: flex-start;
  display: flex;
  flex-direction: row;
  font-size: 10.5px;
}

.agesCodeclicked {
  background-color: black;
  font-family: 'Rubik';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 150%;
  display: flex;
  align-items: center;
  text-align: center;
  color: #000000;
  padding: 5px;
  color: white;
}

.agesCode {
  font-family: 'Rubik';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 150%;
  display: flex;
  align-items: center;
  text-align: center;
  color: #000000;
  padding: 5px;
  background: #f8f9fa;
}

.eventGradeColabLabel {
  font-weight: 500;
  font-size: 12px;
  margin: 10px auto 0px 2px;
  color: #000000;
  padding: 0px !important;
}

.main-div:focus-visible,.acc-div:focus-visible,.sylmainInput:focus-visible,.sylcode:focus-visible,.syldes:focus-visible ,.input-text-accomodation-des:focus-visible,.tabulate-input:focus-visible,.check-in-input:focus-visible,.error-input:focus-visible,.error-des:focus-visible,.input-err:focus-visible,.input-text-area-error:focus-visible {
  outline: none !important;
}

.AboutOrg .MuiButton-root {
  margin-top: 2px;
  margin-bottom: 0px;
  height: 42px;
  width: auto;
  min-width: unset;
}

.input-control:focus-within label {
  color: #68ad3f;
}

.main-div-adj {
  width: 421px;
  height: 410px;
  background-color: #fff;
  display: flex !important;
  flex-direction: column !important;
  margin-bottom: 0rem !important;
  border-radius: 5px;
}

.sylTable {
  /* width: 1028px !important; */
  min-width:1028px;
  overflow-x: scroll !important;
}

.updateLevelform {
  display: flex !important;
  flex-wrap: wrap;
  margin-top: 20px;
}

.main-div-add-adj {
  width: 421px;
  height: 510px;
  background-color: #fff;
  display: flex !important;
  flex-direction: column !important;
  margin-bottom: 0rem !important;
  border-radius: 5px;
}

.AboutOrg .MuiButton-root:hover {
  border: 2px solid #fbb040;
  background: #fbb040;
  color: #ffffff;
  border-radius: 2px solid #fbb040;
  width: width;
}

.errorPay {
  width: 50% !important;
}

.goLiveMainDIv span {
  word-break: break-word !important;
}

.input-box-org-error {
  color: #424242;
  width: 248px;
  height: 40px;
  border: 1px solid red;
  border-radius: 4px;
  padding: 0px 10px;
  outline: none;
  color: red;
}

.label-head-org-error {
  font-weight: 500;
  font-size: 12px;
  margin: 11px auto 3px 5px;
  color: red;
  padding: 0px !important;
}

.mainfee {
  font-weight: 500;
  font-size: 16px;
  color: #323232;
  padding-top: 17px;
}

.select-container {
  position: relative;
  margin: 0 auto;
  width: 400px;
  box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.7);
}

.select-container .select {
  position: relative;
  background: #0f0e11;
  height: 60px;
}

.select-container .select::after {
  position: absolute;
  content: '';
  width: 15px;
  height: 15px;
  top: 50%;
  right: 15px;
  transform: translateY(-50%) rotate(45deg);
  border-bottom: 2px solid white;
  border-right: 2px solid white;
  cursor: pointer;
  transition: border-color 0.4s;
}

.select-container.active .select::after {
  border: none;
  border-left: 2px solid white;
  border-top: 2px solid white;
}

.select-container .select input {
  position: relative;
  width: 100%;
  height: 100%;
  padding: 0 15px;
  background: none;
  outline: none;
  border: none;
  font-size: 1.4rem;
  color: white;
  cursor: pointer;
}

.select-container .option-container {
  position: relative;
  background: #6e6477;
  height: 0;
  overflow-y: scroll;
  transition: 0.4s;
}

.select-container.active .option-container {
  height: 240px;
}

.select-container .option-container::-webkit-scrollbar {
  border-left: 1px solid rgba(0, 0, 0, 0.2);
  width: 10px;
}

.select-container .option-container::-webkit-scrollbar-thumb {
  background: #0f0e11;
}

.select-container .option-container .option {
  position: relative;
  padding-left: 15px;
  height: 60px;
  border-top: 1px solid rgba(0, 0, 0, 0.3);
  cursor: pointer;
  display: flex;
  align-items: center;
  transition: 0.2s;
}

.select-container .option-container .option.selected {
  background: rgba(0, 0, 0, 0.5);
  pointer-events: none;
}

.select-container .option-container .option:hover {
  background: rgba(0, 0, 0, 0.2);
  padding-left: 20px;
}

.select-container .option-container .option label {
  font-size: 1.1rem;
  color: white;
  cursor: pointer;
}

@media only screen and (max-width: 600px) {
  .main-div-adj {
    width: 85vw;
    height: auto;
    background-color: #fff;
    display: flex !important;
    flex-direction: column !important;
    margin-bottom: 0rem !important;
    border-radius: 5px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .main-div-add-adj {
    width: 85vw;
    height: auto;
    background-color: #fff;
    display: flex !important;
    flex-direction: column !important;
    margin-bottom: 0rem !important;
    border-radius: 5px;
  }

  .updateLevelform {
    display: grid !important;
  }

  .main-div-adj form {
    margin: auto 50%;
  }

  .main-div-add-adj form {
    margin: auto 50%;
  }

  .color-subtitle {
    margin-top: 12px !important;
  }

  .main-div form {
    margin: auto 50%;
  }
  .input-text {
    width: -webkit-fill-available !important;
  }

  .stripeLink {
    display: flex;
    flex-direction: column;
  }



  .abountEventLive {
    display: grid !important;
  }

  .errorPay {
    width: 100% !important;
  }

  .accordion-body {
    padding: var(--bs-accordion-body-padding-y)
      var(--bs-accordion-body-padding-x);
    overflow-x: scroll;
  }

  .goLiveDes {
    height: 105px;
    display: inline-grid;
    overflow: scroll;
    width: 93vw !important;
  }
  .backContainer {
    flex-direction: column;
  }

  .headingOrg {
    display: flex;
    margin-top: 1rem;
  }

  .backmainContainer {
    margin-left: -66px;
  }
}

@media only screen and (max-width: 700px) {

  .abountEventLive {
    gap: 34px !important;
  }

  .input-control-err {
    color: red;
  }

  .organizerExam {
    color: #424242;
    justify-content: center;
    align-items: center;
    font-family: 'Rubik';
    font-style: normal;
    font-weight: 400;
    font-size: 20px;
    line-height: 120%;
    padding: 0px;
  }

  .eventSection {
    display: grid !important;
  }
}

@media only screen and (min-width: 800px) {
  #mainContainerStripe {
    max-width: 601px !important;
  }
}

@media only screen and (min-width: 992px) {
  .goLiveMainDIv .col-lg-6 {
    flex: 0 0 auto;
    width: 48%;
  }
}


@media only screen and (min-width: 1400px) {
  #mainContainerStripe {
    max-width: 1052px !important;
  }
}



@media only screen and (min-width: 0px) and (max-width: 480px) {
  .AddedAdjCollab {
    width: 280px;
  }
  .GradeOrgTabList{
    padding-left:7%;
    padding-right:1%;
  }
  .create-feis-content{
    padding-left:7%;
    padding-right:7%;
  }
   .GradeOrgTabList .MuiTabs-flexContainer {
    gap: 20px;
  }
  .GradeOrgTabList .MuiTabs-indicator{
    bottom:0 !important;
    }
    .uploadeDIv{
      width:100%
    }
    .input-text-area {
      width: 100%;
      height: 128px;
    }
    .input-text-area-length{
      width:100%;
    }
    /* .deleteLevel{
      font-size: 12px;
    }
    .userLevel{
      font-size: 14px;
    } */
}
@media only screen and (min-width: 481px) and (max-width: 767px) {
  .GradeOrgTabList{
    padding-left:7%;
    padding-right:1%;
  }
  .create-feis-content{
    padding-left:7%;
    padding-right:7%;
  }
  
.GradeOrgTabList .MuiTabs-indicator{
bottom:0 !important;
}
}

@media only screen and (min-width: 768px) and (max-width: 980px) {
  .GradeOrgTabList{
    padding-left:7%;
    padding-right:7%;
  }
  .create-feis-content{
    padding-left:7%;
    padding-right:7%;
  }
}








`, "",{"version":3,"sources":["webpack://./src/Organizer/GradeEventstyle.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;IACd,eAAe;EACjB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;AACA,gBAAgB;AAChB,kBAAkB;AAClB;;AAEA;EACE,mCAAmC;EACnC,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,+CAA+C;EAC/C,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,yDAAg1B;EACh1B,0BAA0B;AAC5B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;;;;GAIG;;AAEH;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,2CAA2C;EAC3C,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,gCAAgC;EAChC,mBAAmB;EACnB,6CAA6C;EAC7C,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,YAAY;AACd;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,yDAA6Z;EAC7Z,qCAAqC;EACrC,4BAA4B;EAC5B,oCAAoC;EACpC,mBAAmB;EACnB,YAAY;EACZ,0BAA0B;EAC1B,eAAe;EACf,YAAY;AACd;;AAEA;EACE,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,UAAU;EACV,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;AACA;EACE,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,wBAAwB;AAC1B,kBAAkB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,YAAY;EACZ,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;EACxB,qCAAqC;EACrC,4BAA4B;EAC5B,oCAAoC;EACpC,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;EACzB,cAAc;EACd,yDAAgD;AAClD;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,wBAAwB;EACxB,yDAAqpF;EACrpF,qCAAqC;EACrC,4BAA4B;EAC5B,oCAAoC;EACpC,mBAAmB;EACnB,YAAY;EACZ,UAAU;EACV,eAAe;EACf,qBAAqB;EACrB,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;EACxB,yDAAqpF;EACrpF,qCAAqC;EACrC,4BAA4B;EAC5B,oCAAoC;EACpC,mBAAmB;EACnB,YAAY;EACZ,UAAU;EACV,eAAe;EACf,qBAAqB;EACrB,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,qBAAqB;EACrB,wBAAwB;EACxB,yDAAkD;EAClD,mCAAmC;EACnC,4BAA4B;EAC5B,sCAAsC;AACxC;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,wBAAwB;EACxB,yDAAkD;EAClD,mCAAmC;EACnC,4BAA4B;EAC5B,sCAAsC;AACxC;;;AAGA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,qBAAqB;EACrB,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;EACpB,YAAY;EACZ,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,qBAAqB;EACrB,UAAU;EACV,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,QAAQ;EACR,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,2CAA2C;EAC3C,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,oCAAoC;EACpC,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;;EAEE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,oCAAoC;EACpC,uBAAuB;EACvB,oCAAoC;;EAEpC,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,oCAAoC;EACpC,uBAAuB;EACvB,oCAAoC;EACpC,iBAAiB;EACjB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,+BAA+B;EAC/B,gCAAgC;EAChC,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,2BAA2B;EAC3B,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,4BAA4B;EAC5B,mBAAmB;EACnB,kBAAkB;EAClB,+CAA+C;EAC/C,sCAAsC;AACxC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,8CAA8C;EAC9C,8CAA8C;AAChD;;AAEA;EACE,SAAS;EACT,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,eAAe;EACf,cAAc;EACd,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EAGrB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,SAAS;EACT,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,wBAAwB;EACxB,mBAAmB;EACnB,6CAA6C;EAC7C,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,6CAA6C;;EAE7C,UAAU;EACV,QAAQ;EACR,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,gCAAgC;EAChC,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,2BAA2B;EAC3B,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,2BAA2B;EAC3B,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,oCAAoC;EACpC,uBAAuB;EACvB,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,wBAAwB;EACxB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,UAAU;EACV,0BAA0B;EAC1B,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,+BAA+B;EAC/B,qBAAqB;EACrB,qCAAqC;EACrC,oCAAoC;EACpC,8BAA8B;EAC9B,8BAA8B;EAC9B,2BAA2B;EAC3B,6CAA6C;EAC7C,8BAA8B;EAC9B,YAAY;EACZ,oCAAoC;AACtC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,aAAa;EACb,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,oCAAoC;EACpC,UAAU;EACV,QAAQ;EACR,YAAY;EACZ,gBAAgB;EAChB,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,yBAAyB;EACzB,2CAA2C;AAC7C;;AAEA;EACE,qDAAqD;EACrD,iDAAiD;EACjD,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,wBAAwB;EACxB,yBAAyB;AAC3B,kBAAkB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,wBAAwB;EACxB,yBAAyB;AAC3B,kBAAkB;AAClB,iBAAiB;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,wBAAwB;AAC1B;;;AAGA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,2BAA2B;EAC3B,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,wBAAwB;EACxB,iCAAiC;EACjC,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,wBAAwB;EACxB,iCAAiC;EACjC,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,UAAU;EACV,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,QAAQ;EACR,WAAW;EACX,yCAAyC;EACzC,8BAA8B;EAC9B,6BAA6B;EAC7B,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,YAAY;EACZ,iBAAiB;EACjB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yCAAyC;EACzC,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,wCAAwC;EACxC,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE;IACE,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,wBAAwB;IACxB,iCAAiC;IACjC,8BAA8B;IAC9B,kBAAkB;IAClB,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;EAClC;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,wBAAwB;IACxB,iCAAiC;IACjC,8BAA8B;IAC9B,kBAAkB;EACpB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,gBAAgB;EAClB;EACA;IACE,wCAAwC;EAC1C;;EAEA;IACE,aAAa;IACb,sBAAsB;EACxB;;;;EAIA;IACE,wBAAwB;EAC1B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE;wCACoC;IACpC,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,oBAAoB;IACpB,gBAAgB;IAChB,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;;EAEE;IACE,oBAAoB;EACtB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,cAAc;IACd,uBAAuB;IACvB,mBAAmB;IACnB,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,YAAY;EACd;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,cAAc;IACd,UAAU;EACZ;AACF;;;AAGA;EACE;IACE,4BAA4B;EAC9B;AACF;;;;AAIA;EACE;IACE,YAAY;EACd;EACA;IACE,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,gBAAgB;EAClB;GACC;IACC,SAAS;EACX;EACA;IACE,mBAAmB;IACnB;IACA;MACE;IACF;IACA;MACE,WAAW;MACX,aAAa;IACf;IACA;MACE,UAAU;IACZ;IACA;;;;;OAKG;AACP;AACA;EACE;IACE,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,gBAAgB;EAClB;;AAEF;AACA,mBAAmB;AACnB;AACA;;AAEA;EACE;IACE,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,gBAAgB;EAClB;AACF","sourcesContent":[".gapStyle{\n  column-gap: 40px !important;\n  row-gap:10px !important;\n}\n\n.textArea,.textAreaError {\n  white-space: nowrap;  \n  overflow-x: auto;   \n    color:  #424242;;\n  background-color: #fff;\n  border: 1px solid #797979;\n  border-radius: 4px;\n  width:248px;\n  height: 40px; \n  resize: none; \n  line-height: 35px;\n}\n.textAreaError{\n  line-height: 39px;\n}\n\n.textArea::-webkit-scrollbar,.textAreaError::-webkit-scrollbar {\n  display: none;\n}\n.textArea:focus {\n  outline: none; \n}\n.checkbox {\n  position: relative;\n  overflow: hidden;\n  background: none;\n  margin-top: 11px;\n}\n\n.create-feis-content{\npadding-left:18%;\npadding-right: 10%;\n}\n\n#TabSize {\n  /* position: absolute !important; */\n  padding:0;\n}\n.checkbox__input {\n  position: absolute;\n  top: -100px;\n  left: -100px;\n}\n\n.newLevelField {\n  border: 1px solid var(--neutral-chips, #797979);\n  width: auto;\n  height: 42px;\n  border-radius: 4px;\n}\n\n.newLevelField:focus-visible {\n  outline: none;\n}\n\n.checkbox__inner {\n  display: inline-block;\n  width: 19px;\n  height: 19px;\n  border-radius: 28%;\n  border: 1px solid #626262;\n  background: transparent no-repeat center;\n}\n\n.checkbox__input:checked + .checkbox__inner {\n  border-color: #68ad3f;\n  background-color: #68ad3f;\n  background-image: url(\"data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg width='14px' height='10px' viewBox='0 0 14 10' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3C!-- Generator: Sketch 59.1 (86144) - https://sketch.com --%3E%3Ctitle%3Echeck%3C/title%3E%3Cdesc%3ECreated with Sketch.%3C/desc%3E%3Cg id='Page-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cg id='ios_modification' transform='translate(-27.000000, -191.000000)' fill='%23FFFFFF' fill-rule='nonzero'%3E%3Cg id='Group-Copy' transform='translate(0.000000, 164.000000)'%3E%3Cg id='ic-check-18px' transform='translate(25.000000, 23.000000)'%3E%3Cpolygon id='check' points='6.61 11.89 3.5 8.78 2.44 9.84 6.61 14 15.56 5.05 14.5 4'%3E%3C/polygon%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E\");\n  background-size: 14px 10px;\n}\n\n.formikSelectSignorg {\n  width: 248px;\n}\n\n.input-box-org {\n  color: #424242;\n  width: 248px;\n  height: 40px;\n  border: 1px solid #797979;\n  border-radius: 4px;\n  padding-left: 9.94px;\n  outline: none;\n}\n\n.calendar-icon {\n  position: absolute;\n  top: 50%;\n  right: 10px;\n  transform: translateY(-50%);\n}\n\n.label-head-org {\n  font-weight: 500;\n  font-size: 12px;\n  margin: 11px auto 3px 5px;\n  color: #000000;\n  padding: 0px !important;\n}\n\n.card-header {\n  background-color: #68ad3f !important;\n  color: #ffffff !important;\n}\n\n.card-currency {\n  background-color: #68ad3f;\n  color: #ffffff;\n  font-family: 'Rubik';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 12px;\n  padding: 4px;\n}\n\n.card-cont {\n  font-size: 16px;\n}\n\n.card-body {\n  padding: 10px !important;\n}\n\n.pdfDlticon {\n  color: #da1414;\n  cursor: pointer;\n}\n\n/* .fileIcon {\n  padding-right: 20px;\n  padding-left: 22px;\n  color: #424242;\n} */\n\n.fileIcon svg {\n  rotate: 90deg;\n}\n\n.uploadeDIv {\n  width: 410px;\n  min-height: 48px;\n  background: #ffffff;\n  box-shadow: 0px 4px 18px rgba(0, 0, 0, 0.1);\n  border-radius: 4px;\n  font-size: 14px;\n  color: #424242;\n}\n\n.label-head-org iframe {\n  margin-top: 2px;\n}\n\n.AddedAdj,\n.AddedAdjCollab {\n  width: 312px;\n  height: 61px;\n  display: flex;\n  justify-content: space-between;\n  padding: 10.14px 9px 8.89px 14px;\n  background: #ffffff;\n  box-shadow: 0px 15px 28px rgba(0, 0, 0, 0.05);\n  border-radius: 4px;\n  align-items: center;\n  margin-top: 8px;\n  margin-bottom: 8px;\n}\n\n.rightDivAdj svg {\n  cursor: pointer;\n}\n\n.updateChangeDisabled-org-finish:hover {\n  background: #fbb040;\n  cursor: pointer;\n}\n\n.leftDivAdj {\n  display: flex;\n}\n\n.adjImg {\n  display: flex;\n  align-items: center;\n}\n\n.adjImg-adj {\n  display: flex;\n  align-items: center;\n}\n\n.adjDes {\n  display: flex;\n  flex-direction: column;\n  padding-left: 10px;\n}\n\n.adjNAme {\n  font-weight: 400;\n  font-size: 16px;\n  color: #424242;\n}\n\n.adjCoun {\n  font-weight: 500;\n  font-size: 12px;\n  color: #68ad3f;\n  opacity: 0.6;\n}\n\n.rightDivAdj svg {\n  color: #da1414;\n  opacity: 0.6;\n  height: 16px;\n}\n\n.auth-suc {\n  color: #68ad3f;\n  font-size: 12px;\n}\n\n.adjdet {\n  font-family: 'Rubik';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 16px;\n  color: #424242;\n}\n\n.adjImg img {\n  width: 25.14px;\n  height: 25.14px;\n  border-radius: 50%;\n}\n\n.input-box-org-select,.input-box-org-select-disabled {\n  -webkit-appearance: none;\n  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAYCAYAAACMcW/9AAAACXBIWXMAACE4AAAhOAFFljFgAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACnSURBVHgBzdfJDcAgDARAd04JlOASKYEEEn8SQjh8rWSJB2JHiA8AV8I56Z4I9ml6yiI/BsEuCG9PgVd1Bh9Y/LCkHlQbix1HhYbOBi0s/hji6EZJ7HS3BXa5UxO73aWBZeuQxLKfLYEVuwDOg8WfFEeBOJKjSA25U6iOXCk2Q84AzJGjWBfIHaw6kjKDNUNSRrDmSEoP6wZJaWHdISnly0Df3ACMOQATckHecQwCXQAAAABJRU5ErkJggg==);\n  background-position: top 50% right 6%;\n  background-repeat: no-repeat;\n  background-size: 15px 8px !important;\n  background-size: 4%;\n  width: 248px;\n  padding: 0px 27px 0px 13px;\n  font-size: 14px;\n  height: 40px;\n}\n\n.input-box-org-select-disabled{\n  opacity:0.6 !important;\n}\n.levelCap-Values > div {\n  display: flex;\n  flex-direction: column;\n}\n.levelCap-Values > div input {\n  margin-top: 2px !important;\n}\n.label-head-org-file-error {\n  font-weight: 500;\n  font-size: 12px;\n  margin: 3px 5px;\n  color: red;\n  padding: 0px !important;\n}\n.label-head-org-file {\n  font-weight: 500;\n  font-size: 12px;\n  color: #000000;\n  padding: 0px !important;\n  margin: 3px 5px;\n}\n\n.input-box-org:focus {\n  color: #000000;\n  width: 248px;\n  height: 40px;\n  border: 1px solid #68ad3f;\n  border-radius: 4px;\n  padding-left: 10px;\n  outline: none;\n  color: #68ad3f;\n}\n.input-text-accomodation-des:focus {\n  color: #000000;\n  border: 1px solid #68ad3f;\n  border-radius: 4px;\n  outline: none;\n  color: #68ad3f;\n}\n\n.input-control:focus-within label {\n  color: #68ad3f;\n}\n\n.input-control:focus-visible textarea{\n  border: 1px solid #da1414;\n  outline: none;\n}\n\n.input-control:focus-within textarea {\n  border: 1px solid #68ad3f;\n  color: #68ad3f;\n}\n\n.error-input {\n  border: 1px solid red;\n  width: 55px;\n  height: 42px;\n  border-radius: 6px;\n  padding-left: 11px;\n}\n\n.error-des {\n  border: 1px solid red;\n  width: 140px;\n  height: 43px;\n  border-radius: 6px;\n  /* padding-left: 23px; */\ntext-align: center;\n}\n.error-des::placeholder{\n  margin-left: 0;\n}\n.error-des:focus {\n  border: 1px solid red;\n}\n\n.error-select {\n  border: 1px solid red;\n  width: 80px;\n  height: 41px;\n  border-radius: 6px;\n  font-size: 14px;\n  color: red;\n  padding: 0 3px;\n}\n\n.mainDivLive {\n  margin-top: 32px !important;\n}\n\n.input-box-org-date:focus {\n  width: 248px;\n  height: 40px;\n  border-radius: 4px;\n  outline: none;\n  padding: 0px 10px;\n  cursor: text;\n  border: 1px solid #68ad3f;\n  color: #68ad3f;\n}\n\n.input-box-org-date-disabled {\n  width: 248px;\n  height: 40px;\n  border-radius: 4px;\n  outline: none;\n  padding: 0px 10px;\n  cursor: text;\n  border: 1px solid #797979;\n  color: rgba(0, 0, 0, 0.5);\n}\n\n.input-box-org-select:focus {\n  -webkit-appearance: none;\n  background-position: top 50% right 6%;\n  background-repeat: no-repeat;\n  background-size: 15px 8px !important;\n  background-size: 4%;\n  width: 248px;\n  border: 1px solid #68ad3f;\n  color: #68ad3f;\n  background-image: url('../Assets/selectSuc.svg');\n}\n\n.label-select-org-error {\n  margin: 12px auto 3px 7px;\n  font-size: 12px;\n  color: red;\n}\n\n.input-box-select-error {\n  -webkit-appearance: none;\n  background-image: url(data:image/png;base64,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);\n  background-position: top 50% right 6%;\n  background-repeat: no-repeat;\n  background-size: 15px 8px !important;\n  background-size: 4%;\n  width: 248px;\n  color: red;\n  font-size: 14px;\n  border: 1px solid red;\n  height: 40px;\n  padding: 0px 27px 0px 13px;\n}\n\n.input-box-org-select-error {\n  -webkit-appearance: none;\n  background-image: url(data:image/png;base64,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);\n  background-position: top 50% right 6%;\n  background-repeat: no-repeat;\n  background-size: 15px 8px !important;\n  background-size: 4%;\n  width: 248px;\n  color: red;\n  font-size: 14px;\n  border: 1px solid red;\n  height: 40px;\n  padding: 0px 27px 0px 13px;\n}\n\n.input-box-org-select-error {\n  color: red;\n}\n\n.input-text-area {\n  width: 410px;\n  height: 128px;\n  padding: 10px 8px;\n  border-radius: 5px;\n  border: 1px solid #424242;\n  margin-top: 3px;\n}\n\n.input-text-area-error {\n  width: 410px;\n  height: 128px;\n  padding: 10px 8px;\n  border-radius: 5px;\n  border: 1px solid #da1414;\n  margin-top: 3px;\n}\n\n.input-text-area-length {\n  width: 410px;\n  text-align: right;\n  margin-top: -6px;\n  color: #424242;\n}\n\n.sylSlect {\n  width: 80px;\n  height: 41px;\n  border-radius: 6px;\n  font-size: 14px;\n  border: 1px solid #797979;\n  padding: 0 3px;\n  text-align: center;\n  padding: 0 15px 0 8px;\n  -webkit-appearance: none;\n  background-image: url('../Assets/selectArrow.png');\n  background-size: 9px 5px !important;\n  background-repeat: no-repeat;\n  background-position: top 53% right 10%;\n}\n.sylSlectGender {\n  width: 80px;\n  height: 41px;\n  border-radius: 6px;\n  font-size: 14px;\n  border: 1px solid #797979;\n  padding: 0 15px 0 8px;\n  text-align: left;\n  -webkit-appearance: none;\n  background-image: url('../Assets/selectArrow.png');\n  background-size: 9px 5px !important;\n  background-repeat: no-repeat;\n  background-position: top 53% right 10%;\n}\n\n\ntable {\n  border-collapse: collapse;\n}\n\nthead th:first-child {\n  border-radius: 4px 0 0 0 !important;\n}\n\nthead th:last-child {\n  border-radius: 0 4px 0 0;\n}\n\n.stripeContainer {\n  padding: 0px 50px !important;\n}\n\n.sveSyllabus {\n  color: #68ad3f;\n  cursor: pointer;\n}\n\n.auth-error-syl {\n  color: red;\n  font-size: 12px;\n  height: 0px;\n}\n\n.iconsave {\n  display: flex;\n  gap: 29px;\n  align-items: center;\n}\n\n.DidnontFind {\n  font-family: 'Rubik';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 12px;\n  color: #000000;\n  margin-top: 20px;\n}\n\n.input-box-org-des-error {\n  width: 248px;\n  height: 120px;\n  border: 1px solid red;\n  outline: none;\n  color: red;\n}\n\n.syllabusMain input::placeholder {\n  color: #c9c9c9 !important;\n}\n\n#feisOrgGrade .MuiTabs-indicator {\n  height: 3px !important;\n}\n\n.headingOrg {\n  display: flex;\n  margin-top: 2rem;\n  padding: 0 7%;\n}\n\n.sylCheckbox[type='checkbox'] {\n  vertical-align: middle;\n  accent-color: #5a9935;\n  margin-right: 10px;\n  border: 2px solid;\n  border-radius: 197px;\n  height: 64px;\n  width: 20px;\n  color: #797979;\n}\n\n.input-text-area:focus-visible {\n  outline: none;\n}\n\n.accordion-button {\n  box-shadow: none;\n  align-items: flex-end;\n}\n\n.accordion-button:focus {\n  z-index: 3;\n  border-color: #ffffff;\n  outline: 0;\n  box-shadow: none !important;\n  border-color: #eaeaea;\n}\n\n.organizerExam {\n  color: #424242;\n  justify-content: center;\n  align-items: center;\n  font-weight: 400;\n  font-size: 24px;\n  padding-left: 1.5rem;\n}\n\n.accordion-item {\n  border: none !important;\n}\n\n.AccomodationHead button {\n  box-shadow: none;\n  border: none !important;\n}\n\n.eventDetailsBlock {\n  font-family: 'Rubik';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 22px;\n  color: #424242;\n}\n\n.LiveData {\n  color: #424242;\n  margin-top: 10px;\n}\n\n.eventsHr {\n  margin: 0px;\n  margin-top: 8px;\n  background-color: #eaeaea;\n  height: 1.3px;\n}\n\n.goLiveMAin {\n  background-color: #eaeaea;\n  height: 2px;\n}\n\n.latefee {\n  justify-content: space-between;\n}\n\n.subKey {\n  opacity: 0.6;\n}\n\n.abountEventLive .dummy {\n  width: 65%;\n}\n\n.abountEventLive .dummy2 {\n  width: 35%;\n}\n\n.fileShow {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: 9px 11px;\n  gap: 8px;\n  width: 358px;\n  height: auto;\n  background: #ffffff;\n  box-shadow: 0px 4px 18px rgba(0, 0, 0, 0.1);\n  border-radius: 4px;\n}\n\n.attachFile {\n  rotate: 90deg;\n  font-size: 1.2rem !important;\n}\n\n.ROwLive {\n  justify-content: space-between;\n}\n\n.detailsHeading {\n  font-weight: 500;\n  font-size: 12px;\n  color: #000000;\n  padding-top: 17px;\n}\n\n.editIcon {\n  float: right;\n  color: #68ad3f;\n  cursor: pointer;\n  margin-right: 20px;\n}\n\n.OrgGradeMain .MuiTabs-flexContainer {\n  margin: auto;\n  justify-content: center;\n  gap: 40px;\n}\n\n.steps {\n  font-size: 14px;\n  line-height: 17px;\n  color: #323232;\n  opacity: 0.2;\n}\n\n.updateChangeDisabledOrg {\n  opacity: 0.3;\n  background-color: #68ad3f !important;\n  color: white !important;\n  pointer-events: none;\n}\n\n.input-text-accomodation,\n.input-text-accomodation-des {\n  width: 248px;\n  height: 120px;\n}\n\n.input-text-accomodation::placeholder {\n  padding-left: 40%;\n  padding-top: 15%;\n}\n\n.updateChange {\n  width: fit-content;\n  height: 42px;\n  padding: 9px 11px;\n}\n\n.updateChange:hover {\n  background-color: rgb(251, 176, 64);\n}\n\n.accordion-body {\n  padding: unset !important;\n}\n\n.updateChangeOrg {\n  cursor: pointer;\n  background-color: #68ad3f !important;\n  color: white !important;\n  border: 2px solid #68ad3f !important;\n\n  padding: 9px 11px;\n}\n\n.updateChangeOrgDisabled {\n  cursor: pointer;\n  background-color: #68ad3f !important;\n  color: white !important;\n  border: 2px solid #68ad3f !important;\n  padding: 9px 11px;\n  opacity: 0.75;\n  cursor: not-allowed;\n}\n\n.list-group {\n  width: 248px;\n}\n\n.list-group-item + .list-group-item {\n  border-top-width: 0;\n  cursor: pointer !important;\n}\n\n.list-group-item:first-child {\n  border-top-left-radius: inherit;\n  border-top-right-radius: inherit;\n  cursor: pointer !important;\n}\n\n.abountEventLive {\n  display: flex;\n  justify-content: space-between;\n}\n\n.strConnect {\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 150%;\n  background-color: #68ad3f;\n  color: #ffffff;\n  box-shadow: none;\n  border-radius: 4px;\n  padding: 9px 11px;\n  border: none;\n  margin-top: 1em;\n  border: 2px solid #68ad3f;\n  margin: 1.5rem 0px 20px 0px;\n  height: 45px;\n  width: fit-content;\n}\n\n.strConnect:hover {\n  background-color: #fbb040;\n  border: 2px solid #fbb040;\n}\n\n.stripeLink {\n  display: flex;\n  column-gap: 12px;\n}\n\n.sylmainInput {\n  display: flex;\n  width: 311.5px;\n  padding: 9px 0px 10px 9.94px;\n  align-items: center;\n  border-radius: 4px;\n  border: 1px solid var(--neutral-chips, #797979);\n  background: var(--neutral-white, #fff);\n}\n\n.accordion-button:not(.collapsed)::after {\n  filter: brightness(0);\n}\n\n.updateChangeOrg:hover {\n  background-color: rgb(251, 176, 64) !important;\n  border: 2px solid rgb(251, 176, 64) !important;\n}\n\n.OrgBackSubBtns {\n  gap: 27px;\n  display: flex;\n}\n\n.OrgBack button {\n  border: none;\n  color: #68ad3f !important;\n  margin-top: 1em;\n  color: #68ad3f;\n  font-family: 'Rubik';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 150%;\n  text-align: center;\n  color: #68ad3f;\n  background: inherit;\n  box-shadow: none;\n  padding-left: 0;\n}\n\n.OrgGradeMain .Mui-selected {\n  padding: 0px !important;\n}\n\n.OrgGradeMain .MuiContainer-root {\n  padding: 0px !important;\n}\n\n.Aboutevent {\n  padding-right: 6rem;\n}\n\n.OrgGradeMain .MuiButtonBase-root {\n  padding: 0px !important;\n}\n\n.plusIconbtn .css-84skdf-MuiButtonBase-root-MuiButton-root:hover:hover {\n  border: 1px solid #fbb040 !important;\n}\n\n.GradeOrgTabList{\n  padding-left: 18%;\n  padding-right: 18%;\n}\n\n.GradeOrgTabList .MuiTabs-indicator {\n  height: 3px !important;\n  border-radius: 4px;\n}\n\n.GradeOrgTabList .Mui-selected {\n  color: #68ad3f;\n  opacity: 1 !important;\n}\n\n.GradeOrgTabList .MuiButtonBase-root {\n  padding: 0px !important;\n  color: #424242;\n  opacity: 0.6;\n  font-weight: 400;\n  min-width: 0 !important;\n}\n\n.GradeOrgTabList .MuiContainer-root {\n  padding: 0px !important;\n}\n\n.GradeOrgTabList .MuiTabPanel-root {\n  color: #68ad3f;\n  padding: 0px;\n}\n\n.GradeOrgTabList .MuiTabs-scroller {\n  position: relative;\n  display: inline-block;\n  -webkit-flex: 1 1 auto;\n  -ms-flex: 1 1 auto;\n  flex: 1 1 auto;\n  white-space: nowrap;\n  overflow-x: hidden;\n  width: 100%;\n  overflow-x: scroll !important;\n}\n\n.GradeOrgTabList .css-1c0cfyw {\n  width: 100%;\n  margin-left: auto;\n  box-sizing: border-box;\n  margin-right: auto;\n  display: block;\n  padding-left: 0px;\n  padding-right: 16px;\n}\n\n.eventSection {\n  display: flex !important;\n}\n\n.org-select {\n  margin: 12px auto 3px 7px;\n  font-size: 12px;\n  color: #000000;\n}\n\n.input-text-area::-webkit-scrollbar {\n  display: none;\n}\n\n.input-text-accomodation-des::-webkit-scrollbar {\n  display: none;\n}\n\n.adjImg-acc {\n  position: absolute;\n  width: 89.64px;\n  height: 99.74px;\n  left: 0px;\n  top: 0px;\n}\n\n.rightDivAdj {\n  padding: 7px 9px 7px 10px;\n  margin-top: -16px;\n}\n\n.AddedAdj-dec {\n  width: 312px;\n  height: 61px;\n  display: flex;\n  justify-content: space-between;\n  /* padding: 10px 21px; */\n  background: #ffffff;\n  box-shadow: 0px 15px 28px rgba(0, 0, 0, 0.05);\n  border-radius: 4px;\n  align-items: center;\n  margin-top: 8px;\n  width: 311px;\n  height: 100px;\n  background: #ffffff;\n  box-shadow: 0px 15px 28px rgba(0, 0, 0, 0.05);\n\n  flex: none;\n  order: 1;\n  flex-grow: 0;\n  margin-bottom: 8px;\n}\n\n.adjImg-adj img {\n  height: 100px;\n  aspect-ratio: 1/1;\n  border-radius: 4px 0px 0px 4px;\n}\n\n.goLiveDes {\n  max-height: 219px;\n  display: inline-grid;\n  overflow: scroll;\n  width: 482px;\n  padding: 0px 5px;\n}\n\n.latefee div {\n  width: 50%;\n}\n\n.goLiveDes::-webkit-scrollbar {\n  display: none;\n}\n\n.eventPage {\n  font-family: 'Rubik';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 22px;\n  line-height: 120%;\n  color: #424242;\n}\n\n.eventDescription {\n  font-style: normal;\n  font-weight: 400;\n  font-size: 16px;\n  color: #424242;\n  border-bottom: 1px solid #eaeaea;\n  padding-bottom: 8px;\n  margin-bottom: 28px;\n}\n\n.paymentTab button {\n  min-width: 0;\n}\n\n.input-box-org-date {\n  color: #000000;\n  width: 248px;\n  height: 40px;\n  border: 1px solid #797979;\n  border-radius: 4px;\n  outline: none;\n  padding: 0px 10px;\n  cursor: text;\n}\n\n.EventDateOrg {\n  font-weight: 500;\n  font-size: 22px !important;\n  color: #323232;\n  padding: 32px 0px 0px 0px;\n}\n\n.detailsHeaders {\n  padding: 20px 0px 0px 0px;\n}\n\n.connectOrgAccount {\n  font-family: 'Rubik';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 150%;\n  color: #68ad3f;\n  background: inherit;\n  box-shadow: none;\n  border-radius: 4px;\n  padding: 9px 11px;\n  border: none;\n  margin-top: 1em;\n  border: 2px solid #68ad3f;\n  margin: 1.5rem 0px 20px 0px;\n  height: 45px;\n  width: max-content;\n}\n.connectOrgAccountstripe {\n  font-family: 'Rubik';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 150%;\n  color: #68ad3f;\n  background: inherit;\n  box-shadow: none;\n  border-radius: 4px;\n  padding: 9px 11px;\n  border: none;\n  margin-top: 1em;\n  border: 2px solid #68ad3f;\n  margin: 1.5rem 0px 20px 0px;\n  height: 45px;\n  width: fit-content;\n}\n\n.updateChangeDisabled-org {\n  opacity: 0.3;\n  background-color: #68ad3f !important;\n  color: white !important;\n  pointer-events: none;\n  width: 59px;\n  height: 42px;\n  padding: 9px 11px;\n}\n\n.EventHeader-org h4 {\n  font-family: 'Rubik';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 150%;\n  padding: 6px 0px 6px 0px;\n  color: #323232;\n}\n\n.connectOrgAccount:hover {\n  background: #fbb040;\n  color: #ffffff;\n  border: 2px solid #fbb040;\n}\n\n.dltSyllabus {\n  color: #da1414;\n  cursor: pointer;\n}\n\n.plusIconbtn:hover #plusICon {\n  visibility: collapse !important;\n  width: 0px;\n  transition-property: width;\n  transition-duration: 0.3s;\n  border: 2px solid;\n}\n\n.plusIconbtn .css-i4bv87-MuiSvgIcon-root {\n  margin: 0 5px 0 0;\n}\n\n.plusIconbtnOrg {\n  font-family: 'Rubik';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  color: #68ad3f;\n}\n\n.plusIconbtnOrg :hover #plusICon {\n  visibility: collapse !important;\n  width: 0px !important;\n  transition-property: width !important;\n  transition-duration: 0.3s !important;\n  border: '2px solid' !important;\n  background: #fbb040 !important;\n  color: '#ffffff' !important;\n  border-radius: '2px solid #fbb040' !important;\n  background: #fbb040 !important;\n  color: white;\n  border: 1px solid #fbb040 !important;\n}\n\n.plusIconbtnOrg .css-i4bv87-MuiSvgIcon-root {\n  margin: 0 5px 0 0;\n}\n\n.updateChangeDisabled-org-finish {\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 150%;\n  padding: 9px 11px;\n  color: #ffffff;\n}\n\n.plusIconbtnOrg .css-i4bv87-MuiSvgIcon-root:hover {\n  margin: 0 5px 0 0;\n  background: #fbb040 !important;\n}\n\n.OrgGradeMain .css-xdmu94-MuiContainer-root {\n  padding: 0px;\n}\n\n.backdiv {\n  color: #68ad3f;\n  padding: 17px 0px 16px 0px;\n}\n\n.BackMain {\n  font-weight: 500;\n  font-size: 16px;\n  padding-left: 11.59px;\n  text-align: center;\n}\n\n.logoImg {\n  padding-top: 13px;\n  display: flex;\n  gap: 9px;\n}\n\n.SYLiCON {\n  cursor: pointer;\n}\n\n.SYLiCON-save {\n  fill: #da1414 !important;\n  cursor: pointer;\n}\n\n.SYLiCON-save-disabled {\n  fill: #000000 !important;\n  opacity: 0.6;\n}\n\n.logoImg img {\n  width: 40.75px;\n  height: 39px;\n  left: -2.19px;\n  bottom: 0px;\n}\n\n.EventNAme {\n  font-weight: 400;\n  font-size: 24px;\n  text-align: center;\n  color: #424242;\n}\n\n.ExamNAme {\n  font-weight: 500;\n  font-size: 12px;\n  text-align: center;\n  color: #68ad3f;\n  padding: 2px 0px 0px 10px;\n}\n\n.goLiveButton button {\n  background: #68ad3f;\n  color: #ffffff;\n  padding: 9px 11px;\n  border-radius: 4px;\n  border: 2px solid #68ad3f;\n}\n\n.goLiveButton button:hover {\n  background: #fbb040;\n  border: 2px solid #fbb040;\n}\n\n.examVenue {\n  font-weight: 400;\n  font-size: 14px;\n  color: #000000;\n  padding-left: 9px;\n}\n\n.userLevel {\n  font-family: 'Rubik';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 22px;\n  color: #424242;\n}\n\n.deleteIcon svg {\n  color: #68ad3f;\n  margin-left: 21px;\n}\n\n.deleteLevel {\n  font-family: 'Rubik';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  text-align:center;\n  color: #68ad3f;\n}\n\n.accordion-button {\n  background-color: #ffffff !important;\n  border-color: #ffffff;\n}\n\n#accordationHeader button {\n  padding: 3px !important;\n}\n\n.deleteButton {\n  border: none;\n  box-shadow: none;\n  background-color: inherit !important;\n}\n\n.header-item > button {\n  padding-left: 0;\n  padding-right: 0;\n  width: 100%;\n}\n\n.accordion-item {\n  box-shadow: none;\n}\n\n.updateLevel {\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 150%;\n  color: #68ad3f;\n  border: 2px solid #68ad3f !important;\n  flex: none;\n  order: 1;\n  flex-grow: 0;\n  box-shadow: none;\n  margin-left: 20px !important;\n  border-radius: 4px !important;\n}\n\n.updateLevel:hover {\n  border: 2px solid #fbb040 !important;\n  background: #fbb040 !important;\n  color: #ffffff !important;\n  border-radius: 2px solid #fbb040 !important;\n}\n\n.accordion-button:not(.collapsed)::after {\n  background-image: var(--bs-accordion-btn-active-icon);\n  transform: var(--bs-accordion-btn-icon-transform);\n  color: black !important;\n  background-image: balck;\n}\n\n.input-box-org-date-error {\n  color: #000000;\n  width: 248px;\n  height: 40px;\n  border: 1px solid red;\n  border-radius: 4px;\n  outline: none;\n  padding: 0px 10px;\n  color: red;\n}\n\n.tableHeadSyl {\n  background: #eaeaea;\n  border-radius: 2px;\n  margin-top: 3rem;\n}\n\n.tableSylTh {\n  font-weight: 400;\n  font-size: 14px;\n  align-items: center;\n  color: #424242;\n  text-align: center;\n  background: #EAEAEA !important;\n}\n\n.sylTablediv {\n  width: 67vw !important;\n  overflow-x: scroll !important;\n}\n\n.sylcode {\n  width: 55px;\n  height: 42px;\n  border-radius: 6px;\n  /* padding-left: 11px; */\n  border: 1px solid #797979;\ntext-align: center;\n}\n\n.sylcode::placeholder {\n  padding: 1px;\n  margin-left:0;\n}\n\n.sylageCode {\n  margin: 1px;\n}\n\n.syldes {\n  width: 140px;\n  height: 43px;\n  border-radius: 6px;\n  /* padding-left: 23px; */\n  border: 1px solid #797979;\ntext-align: center;\npadding-left: 5px;\n}\n\n.agesselected {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: 5px;\n  height: 31px;\n  background: #6c757d;\n  color: #ffffff;\n  border: 1px solid #424242;\n  margin: 2px;\n  cursor:pointer;\n}\n\n.agesselected input,.agesunselected input{\n  display: none !important;\n}\n\n\n.agesunselected {\n  color: #000000;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: 5px;\n  height: 31px;\n  background: #f8f9fa;\n  border: 1px solid #f8f9fa;\n  margin: 2px;\n  cursor:pointer;\n}\n\n.syldes::placeholder {\n  padding-left: 1px;\n  margin-left: 0;\n}\n\n.agesCodetd {\n  display: flex;\n  flex-wrap: wrap;\n  text-decoration: none;\n  padding: 9px 0px !important;\n  align-items: flex-start;\n  display: flex;\n  flex-direction: row;\n  font-size: 10.5px;\n}\n\n.agesCodeclicked {\n  background-color: black;\n  font-family: 'Rubik';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 150%;\n  display: flex;\n  align-items: center;\n  text-align: center;\n  color: #000000;\n  padding: 5px;\n  color: white;\n}\n\n.agesCode {\n  font-family: 'Rubik';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 150%;\n  display: flex;\n  align-items: center;\n  text-align: center;\n  color: #000000;\n  padding: 5px;\n  background: #f8f9fa;\n}\n\n.eventGradeColabLabel {\n  font-weight: 500;\n  font-size: 12px;\n  margin: 10px auto 0px 2px;\n  color: #000000;\n  padding: 0px !important;\n}\n\n.main-div:focus-visible,.acc-div:focus-visible,.sylmainInput:focus-visible,.sylcode:focus-visible,.syldes:focus-visible ,.input-text-accomodation-des:focus-visible,.tabulate-input:focus-visible,.check-in-input:focus-visible,.error-input:focus-visible,.error-des:focus-visible,.input-err:focus-visible,.input-text-area-error:focus-visible {\n  outline: none !important;\n}\n\n.AboutOrg .MuiButton-root {\n  margin-top: 2px;\n  margin-bottom: 0px;\n  height: 42px;\n  width: auto;\n  min-width: unset;\n}\n\n.input-control:focus-within label {\n  color: #68ad3f;\n}\n\n.main-div-adj {\n  width: 421px;\n  height: 410px;\n  background-color: #fff;\n  display: flex !important;\n  flex-direction: column !important;\n  margin-bottom: 0rem !important;\n  border-radius: 5px;\n}\n\n.sylTable {\n  /* width: 1028px !important; */\n  min-width:1028px;\n  overflow-x: scroll !important;\n}\n\n.updateLevelform {\n  display: flex !important;\n  flex-wrap: wrap;\n  margin-top: 20px;\n}\n\n.main-div-add-adj {\n  width: 421px;\n  height: 510px;\n  background-color: #fff;\n  display: flex !important;\n  flex-direction: column !important;\n  margin-bottom: 0rem !important;\n  border-radius: 5px;\n}\n\n.AboutOrg .MuiButton-root:hover {\n  border: 2px solid #fbb040;\n  background: #fbb040;\n  color: #ffffff;\n  border-radius: 2px solid #fbb040;\n  width: width;\n}\n\n.errorPay {\n  width: 50% !important;\n}\n\n.goLiveMainDIv span {\n  word-break: break-word !important;\n}\n\n.input-box-org-error {\n  color: #424242;\n  width: 248px;\n  height: 40px;\n  border: 1px solid red;\n  border-radius: 4px;\n  padding: 0px 10px;\n  outline: none;\n  color: red;\n}\n\n.label-head-org-error {\n  font-weight: 500;\n  font-size: 12px;\n  margin: 11px auto 3px 5px;\n  color: red;\n  padding: 0px !important;\n}\n\n.mainfee {\n  font-weight: 500;\n  font-size: 16px;\n  color: #323232;\n  padding-top: 17px;\n}\n\n.select-container {\n  position: relative;\n  margin: 0 auto;\n  width: 400px;\n  box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.7);\n}\n\n.select-container .select {\n  position: relative;\n  background: #0f0e11;\n  height: 60px;\n}\n\n.select-container .select::after {\n  position: absolute;\n  content: '';\n  width: 15px;\n  height: 15px;\n  top: 50%;\n  right: 15px;\n  transform: translateY(-50%) rotate(45deg);\n  border-bottom: 2px solid white;\n  border-right: 2px solid white;\n  cursor: pointer;\n  transition: border-color 0.4s;\n}\n\n.select-container.active .select::after {\n  border: none;\n  border-left: 2px solid white;\n  border-top: 2px solid white;\n}\n\n.select-container .select input {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  padding: 0 15px;\n  background: none;\n  outline: none;\n  border: none;\n  font-size: 1.4rem;\n  color: white;\n  cursor: pointer;\n}\n\n.select-container .option-container {\n  position: relative;\n  background: #6e6477;\n  height: 0;\n  overflow-y: scroll;\n  transition: 0.4s;\n}\n\n.select-container.active .option-container {\n  height: 240px;\n}\n\n.select-container .option-container::-webkit-scrollbar {\n  border-left: 1px solid rgba(0, 0, 0, 0.2);\n  width: 10px;\n}\n\n.select-container .option-container::-webkit-scrollbar-thumb {\n  background: #0f0e11;\n}\n\n.select-container .option-container .option {\n  position: relative;\n  padding-left: 15px;\n  height: 60px;\n  border-top: 1px solid rgba(0, 0, 0, 0.3);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  transition: 0.2s;\n}\n\n.select-container .option-container .option.selected {\n  background: rgba(0, 0, 0, 0.5);\n  pointer-events: none;\n}\n\n.select-container .option-container .option:hover {\n  background: rgba(0, 0, 0, 0.2);\n  padding-left: 20px;\n}\n\n.select-container .option-container .option label {\n  font-size: 1.1rem;\n  color: white;\n  cursor: pointer;\n}\n\n@media only screen and (max-width: 600px) {\n  .main-div-adj {\n    width: 85vw;\n    height: auto;\n    background-color: #fff;\n    display: flex !important;\n    flex-direction: column !important;\n    margin-bottom: 0rem !important;\n    border-radius: 5px;\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n  }\n\n  .main-div-add-adj {\n    width: 85vw;\n    height: auto;\n    background-color: #fff;\n    display: flex !important;\n    flex-direction: column !important;\n    margin-bottom: 0rem !important;\n    border-radius: 5px;\n  }\n\n  .updateLevelform {\n    display: grid !important;\n  }\n\n  .main-div-adj form {\n    margin: auto 50%;\n  }\n\n  .main-div-add-adj form {\n    margin: auto 50%;\n  }\n\n  .color-subtitle {\n    margin-top: 12px !important;\n  }\n\n  .main-div form {\n    margin: auto 50%;\n  }\n  .input-text {\n    width: -webkit-fill-available !important;\n  }\n\n  .stripeLink {\n    display: flex;\n    flex-direction: column;\n  }\n\n\n\n  .abountEventLive {\n    display: grid !important;\n  }\n\n  .errorPay {\n    width: 100% !important;\n  }\n\n  .accordion-body {\n    padding: var(--bs-accordion-body-padding-y)\n      var(--bs-accordion-body-padding-x);\n    overflow-x: scroll;\n  }\n\n  .goLiveDes {\n    height: 105px;\n    display: inline-grid;\n    overflow: scroll;\n    width: 93vw !important;\n  }\n  .backContainer {\n    flex-direction: column;\n  }\n\n  .headingOrg {\n    display: flex;\n    margin-top: 1rem;\n  }\n\n  .backmainContainer {\n    margin-left: -66px;\n  }\n}\n\n@media only screen and (max-width: 700px) {\n\n  .abountEventLive {\n    gap: 34px !important;\n  }\n\n  .input-control-err {\n    color: red;\n  }\n\n  .organizerExam {\n    color: #424242;\n    justify-content: center;\n    align-items: center;\n    font-family: 'Rubik';\n    font-style: normal;\n    font-weight: 400;\n    font-size: 20px;\n    line-height: 120%;\n    padding: 0px;\n  }\n\n  .eventSection {\n    display: grid !important;\n  }\n}\n\n@media only screen and (min-width: 800px) {\n  #mainContainerStripe {\n    max-width: 601px !important;\n  }\n}\n\n@media only screen and (min-width: 992px) {\n  .goLiveMainDIv .col-lg-6 {\n    flex: 0 0 auto;\n    width: 48%;\n  }\n}\n\n\n@media only screen and (min-width: 1400px) {\n  #mainContainerStripe {\n    max-width: 1052px !important;\n  }\n}\n\n\n\n@media only screen and (min-width: 0px) and (max-width: 480px) {\n  .AddedAdjCollab {\n    width: 280px;\n  }\n  .GradeOrgTabList{\n    padding-left:7%;\n    padding-right:1%;\n  }\n  .create-feis-content{\n    padding-left:7%;\n    padding-right:7%;\n  }\n   .GradeOrgTabList .MuiTabs-flexContainer {\n    gap: 20px;\n  }\n  .GradeOrgTabList .MuiTabs-indicator{\n    bottom:0 !important;\n    }\n    .uploadeDIv{\n      width:100%\n    }\n    .input-text-area {\n      width: 100%;\n      height: 128px;\n    }\n    .input-text-area-length{\n      width:100%;\n    }\n    /* .deleteLevel{\n      font-size: 12px;\n    }\n    .userLevel{\n      font-size: 14px;\n    } */\n}\n@media only screen and (min-width: 481px) and (max-width: 767px) {\n  .GradeOrgTabList{\n    padding-left:7%;\n    padding-right:1%;\n  }\n  .create-feis-content{\n    padding-left:7%;\n    padding-right:7%;\n  }\n  \n.GradeOrgTabList .MuiTabs-indicator{\nbottom:0 !important;\n}\n}\n\n@media only screen and (min-width: 768px) and (max-width: 980px) {\n  .GradeOrgTabList{\n    padding-left:7%;\n    padding-right:7%;\n  }\n  .create-feis-content{\n    padding-left:7%;\n    padding-right:7%;\n  }\n}\n\n\n\n\n\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
